var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('responsible-list',{attrs:{"users":_vm.item.watchers,"item":_vm.item,"endpoint":"api/user/watchers/task","payloadName":"watchers"}})}
var staticRenderFns = []

export { render, staticRenderFns }